<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<br/><br/><br/><br/>
<div class="figure" style="text-align: center;">
<img alt="" src="media/0.JPG"/>
<p class="caption">http://farm8.staticflickr.com/7144/6630495777_7035e464a7.jpg</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?bf46f732